import cn from 'classnames';
import React__default, { useMemo } from 'react';
import { Typography, Space } from '@sravni/react-design-system';
import { HOW_WE_WORK_TITLE, LINK_HOW_WE_WORK, TEXT_BUTTON_HOW_WE_WORK } from '../../constants/components.js';
import { IS_ADD_REVIED_PAGE_DATA, IS_NOT_ADD_REVIED_PAGE_DATA } from '../../helpers/data.js';
import modules_77a29656 from '../../reviews-action-block.module.scss.js';
import { HowWeWorkIcon } from '../HowWeWorkIcon/index.js';

const HowWeWork = ({ isAddReviewPage }) => {
    const listData = isAddReviewPage ? IS_ADD_REVIED_PAGE_DATA : IS_NOT_ADD_REVIED_PAGE_DATA;
    const list = useMemo(() => {
        return listData.map(({ text, icon }, i) => React__default.createElement(HowWeWorkIcon, { text: text, icon: icon, key: i }));
    }, [listData]);
    const Title = (isAddReviewPage ? Typography.Heading : Typography.Text);
    const titleProps = isAddReviewPage
        ? { level: 4, className: 'h-mb-12' }
        : { strong: true, size: 14 };
    return (React__default.createElement(Space, { className: cn(isAddReviewPage && modules_77a29656.wrapper), direction: "vertical", size: 12 },
        React__default.createElement(Title, { ...titleProps }, HOW_WE_WORK_TITLE),
        list,
        isAddReviewPage && (React__default.createElement(Typography.Link, { href: LINK_HOW_WE_WORK, target: "_blank", strong: true, className: "h-mt-12" }, TEXT_BUTTON_HOW_WE_WORK))));
};

export { HowWeWork };
//# sourceMappingURL=index.js.map
